// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaW = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16.551 8.008h1.566v.553l-2.079 9.14h-2.227l-.986-4.469c-.526-2.403-.594-2.767-.756-3.78h-.08a66 66 0 01-.743 3.659L10.22 17.7H7.884L5.9 8.56v-.553h1.647l.702 3.631q.106.556.215 1.104c.229 1.167.45 2.3.595 3.338h.08c.196-1.158.477-2.376.776-3.669l.224-.975.783-3.43h2.268l.729 3.227c.391 1.769.77 3.483.985 4.847h.081c.137-1.07.417-2.436.712-3.873l.166-.812z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaW;
